module.exports = __webpack_public_path__ + "static/media/iconmonstr-linkedin-3.d5f913e9.svg";